import { tracked } from '@glimmer/tracking';
import BillingItemMixin from 'client-portal/mixins/polymorphic/billing-item';
import Model, { attr } from '@ember-data/model';

export default class StatementModel extends Model.extend(BillingItemMixin) {
  @attr() displayName;
  @attr('moment') createdAt;
  @attr() isNewForClient;

  get isUnread() {
    return !this.opened && this.isNewForClient;
  }

  // Tracked so `isUnread` recomputes when `billing-modals` marks the statement
  // as opened (via `model.set('opened', true)`); matches receipt.js.
  @tracked opened = false;
}
